import { IntlShape } from "react-intl";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, ITermsofUseResponse } from "../../Orchestrator/Types/Index";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";

export async function getTermsofUseData(): Promise<IApiResponse<ITermsofUseResponse>> {
  const ENDPOINTS = await getEndpoints();
  const params = new URLSearchParams({
    locale: await getLocaleFromCookie()
  });
  const endpoint = `${ENDPOINTS.getTermsofUse}?${params.toString()}`;
  return await cmsApiRequest<ITermsofUseResponse>(endpoint, "GET");
}
